<template>
    <component :is="tag" class="l-section">
        <div
            v-if="hasIntro"
            class="l-section__intro"
            :class="[
                `-${bgIntro}`,
                { '-image': image },
                `l-section__intro--${introPosition}`,
                { 'l-section__intro--image-bg': image && imageHasBackground },
                { 'l-section__intro--video-bg': videoUrl },
                { 'l-section__intro--return': btnReturn }
            ]"
            v-view.reveal="1.5"
        >
            <!-- intro video -->
            <span class="l-section__bg" v-view="{ handler: viewBgIntro, delay: 3 }">
                <hero-video v-if="videoUrl" :video-url="videoUrl" />
                <asset v-if="image && imageHasBackground" :image="image" :cover="true" />
            </span>
            <slot name="intro">
                <header class="l-section__header">
                    <!-- <hero :title="title" :title-class="titleClass" :desc="desc" :logo="logo" :logo-bottom="logoBottom" /> -->
                    <btn
                        v-if="btnReturn"
                        tag="router-link"
                        :href="btnReturn.path"
                        :label="btnReturn.label"
                        :color="bgIntro"
                        iconBefore="arrow-left"
                        class="l-section__return"
                    />
                    <div v-if="logo && !logoBottom" class="l-section__logo" ref="logo"></div>

                    <hero
                        :title="title"
                        :strap="strap"
                        :title-class="titleClass"
                        :desc="desc"
                        :logo="logo"
                        :logo-bottom="logoBottom"
                    />
                </header>
                <asset v-if="image && !imageHasBackground" :image="image" class="l-section__img" />
                <div v-if="!logo && logoBottom" class="l-section__logo -bottom">
                    <div ref="logo"></div>
                </div>
                <div v-if="push !== ''" class="l-section__bottom">
                    <div class="l-section__arrows" v-view="viewArrows">
                        <icon v-for="i in [1, 2, 3]" :key="i" icon="arrow-right" />
                    </div>
                    <p class="l-section__push">
                        <anim-text :text="push" />
                    </p>
                </div>
            </slot>
        </div>
        <div v-if="$slots.content" class="l-section__content">
            <slot name="content" />
            <span
                v-for="(bg, i) in bgs"
                :key="`bg-${i}`"
                class="l-section__bg"
                :class="`-${i + 1}`"
                v-view="viewBgParallax"
            ></span>
        </div>
    </component>
</template>

<script>
import AnimText from "objects/AnimText";
import Asset from "objects/Asset";
import Btn from "components/Btn";
import Hero from "components/Hero/Hero";
import HeroVideo from "components/HeroVideo/HeroVideo";
import Icon from "objects/Icon";
import PrismicRichText from "objects/PrismicRichText";

import Variables from "src/mixins/variables";

import lottie from "lottie-web";
import gsap from "gsap";

export default {
    name: "AppSection",
    components: {
        AnimText,
        Asset,
        Btn,
        Hero,
        HeroVideo,
        Icon,
        PrismicRichText
    },
    mixins: [Variables],
    props: {
        tag: {
            type: String,
            default: "section"
        },
        logo: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: null
        },
        titleClass: {
            type: String,
            default: "t-t1-heavy"
        },
        desc: {
            type: Array,
            default: () => []
        },
        image: {
            type: Object,
            default: null
        },
        push: {
            type: String,
            default: ""
        },
        bgIntro: {
            type: String,
            default: "bright"
        },
        bgs: {
            type: Number,
            default: 0
        },
        imageHasBackground: {
            type: Boolean,
            default: false
        },
        logoBottom: {
            type: Boolean,
            default: false
        },
        btnReturn: {
            type: Object,
            default: null
        },
        videoUrl: {
            type: Object,
            required: false,
            default: () => {}
        },
        introPosition: {
            type: String,
            required: false,
            default: "center"
        },
        //  subsidiary smaller headline placed over a main headline
        strap: {
            type: Array,
            required: false,
            default: () => []
        }
    },
    data: () => ({
        logoIcon: null,
        logoAnimation: false
    }),
    mounted() {
        this.setAnimation();
    },
    computed: {
        hasIntro() {
            return !!(this.$slots.intro || this.logo || this.title || this.desc.length > 0);
        }
    },
    methods: {
        setAnimation() {
            if (!(this.logo || this.logoBottom)) {
                this.logoAnimation = false;
                return;
            }

            // Destroy autoplaynimation if exists
            if (this.logoAnimation) {
                this.logoAnimation.destroy();
            }

            this.logoAnimation = lottie.loadAnimation({
                container: this.$refs.logo,
                renderer: "svg",
                autoplay: false,
                loop: false,
                animationData: require(`assets/animations/${this.$root.$i18n.locale}/logo.json`)
            });

            if (this.autoplay) {
                this.logoAnimation.play();
            }
        },
        viewBgIntro(e) {
            gsap.to(e.target, {
                duration: 0.4,
                scaleX: this.ifHorizontal(`${1 + e.percent.center.x / 10}px`, 1),
                scaleY: this.ifHorizontal(1, `${1 + e.percent.top / 5}px`),
                ease: "sine.out",
                onStart: () => {
                    if (this.logoAnimation) {
                        this.logoAnimation.play();
                    }
                }
            });
        },
        viewBgParallax(e) {
            if (this.isHorizontal) {
                gsap.to(e.target, {
                    duration: 0.4,
                    x: `${((e.percent.left - 1) * this.W.w) / 8}px`,
                    ease: "sine.out"
                });
            } else {
                //                gsap.to(e.$target, {
                //                    duration: .2,
                //                    y: `${e.percent.top * this.W.h/10}px`
                //                })
            }
        },
        viewArrows(e) {
            gsap.to(e.target, {
                duration: 0.4,
                x: this.ifHorizontal(`${((1 - e.percent.left) * this.W.w) / 30}px`, 0),
                // y: this.ifHorizontal(0, `${((0.8 - e.percent.top) * this.W.h) / 10}px`), // animation is great, but it's not possible to align the text with a si
                y: this.ifHorizontal(0, "33.33%"), // better alignment with the text without full refactoring of the component
                ease: "sine.out"
            });
        }
    }
};
</script>

<style lang="scss">
/*===============================
=            Section            =
===============================*/

.l-section {
    @media #{$breakpoint-vertical} {
    }

    @media #{$breakpoint-horizontal} {
        display: flex;
        align-items: center;
        height: 100%;

        > * {
            flex-shrink: 0;
        }
    }
}

.l-section__intro {
    --color-bg: #{$color-dark};
    --color-text: #{$color-lighter};

    width: 100%;
    height: inherit;
    padding: 3em 1.25rem;

    color: var(--color-text);

    &--video-bg {
        /* min-height: 70vh; */
    }

    &--bottom {
        /* o-anim-text__t have a line height, so set the padding bottom to 0 */
        padding: 1em 1.25rem 0em 1.25em;
    }

    .l-section__bg {
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;

        .o-asset {
            &:before {
                content: " ";
                position: absolute;
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;
                background: black;
                opacity: 0.4;
                z-index: 1;
                @media #{$breakpoint-horizontal} {
                    opacity: 0.2;
                }
            }
        }

        .o-asset,
        .o-asset__img {
            position: absolute;
            top: 0px;
            right: 0px;
            bottom: 0px;
            left: 0px;
            width: 100%;
            height: 100%;
        }
    }

    &.-lighter {
        --color-bg: #{$color-lighter};
        --color-text: #{$color-dark};
    }

    &.-light {
        --color-bg: #{$color-light};
    }

    &.-bright {
        --color-bg: #{$color-bright};
    }

    &.-light,
    &.-bright {
        .l-section__bottom {
            color: $color-dark;
        }
    }

    /* &.-lighter, */
    &--video-bg.-lighter,
    &--image-bg.-lighter
  /* &.-white */ {
        --color-text: #{$color-white};
    }
    &.js-reveal {
        .l-section__header {
            transform: translate(-2em, 0);
        }

        .l-section__desc,
        .l-section__return {
            opacity: 0;
            transform: translate(0, 1rem);
        }

        .l-section__arrows {
            .o-icon {
                overflow: hidden;
            }

            svg {
                transform: translate(-100%, 0);
            }
        }

        &.is-visible {
            .l-section__header {
                transform: translate(0);
                transition: transform 1s $out-quad;
            }

            .l-section__title {
                /* @include anim-text-in(0.6, 0.2); */
                .l-section__intro--video & {
                    color: $color-white;
                }
            }

            .l-section__desc,
            .l-section__return {
                opacity: 1;
                transform: translate(0);
            }

            .l-section__return {
                transition: all 0.6s $out-quad 0.2s;
            }

            .l-section__desc {
                /* transition: all 0.6s $out-quad 0.4s; */
            }

            .l-section__arrows {
                .o-icon {
                    @for $i from 1 through 3 {
                        &:nth-child(#{$i}) svg {
                            $i: $i - 1;
                            transition: transform 0.4s $out-quad #{$i/6 + 0.4}s;
                        }
                    }

                    /* only show the arrow at the center without affecting other pages */
                    &:nth-child(1),
                    &:nth-child(3) {
                        @media #{$breakpoint-vertical} {
                            .p-story &,
                            .p-stories & {
                                opacity: 0;
                            }
                        }
                    }
                }

                svg {
                    transform: translate(0);
                }
            }

            .l-section__push {
                @include anim-text-in(0.4, 0.6);
            }
        }
    }

    @media #{md("xs")} {
        padding-right: 12vw;
        padding-left: 12vw;
    }

    @media #{$breakpoint-vertical} {
        padding-top: $header-width;
        padding-bottom: 5em;

        .l-section__bg {
            transform-origin: 50% 0;
        }

        &.js-reveal {
            .l-section__header {
                transform: translate(0, -1rem);
            }
        }
    }

    @media #{$breakpoint-horizontal} {
        display: flex;
        flex-direction: column;

        /* justify-content: center; */
        width: calc(80vw - var(--header-size));
        width: 80vw; // originaly  calc(80vw - var(--header-size) but I don't this there is any need with the refactored nav
        padding-right: 18vw;

        &--top {
            justify-content: flex-start;
        }
        &--center {
            justify-content: center;
        }
        &--bottom {
            justify-content: flex-end;
        }

        &.-image {
            .l-section__header {
                z-index: 1;
                margin-top: 0;
            }
        }

        .l-section__bg {
            transform-origin: 0 50%;
        }
    }
}

.l-section__header,
.l-section__bottom,
.l-section__logo.-bottom {
    @media #{$breakpoint-vertical} {
        max-width: 32em;
        margin-right: auto;
        margin-left: auto;
    }
}

.l-section__header {
    .l-section__intro--bottom & {
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        align-items: flex-start;
        align-content: flex-end;
        height: 100%;
    }
    .l-section__intro--return & {
        justify-content: space-between;
    }
    @media #{$breakpoint-horizontal} {
        /* margin-top: auto;
    margin-bottom: auto; */
    }
}

.l-section__return {
    margin-bottom: 2em;
}

.l-section__desc {
    margin-top: 1em;

    @media #{md("md")} {
        font-size: 1.18em;
    }
}

.l-section__logo {
    display: block;
    width: 100%;
    margin-bottom: var(--grid-gutter-triple);
    @media #{$breakpoint-horizontal} {
        margin-bottom: 0px;
    }

    & + .l-section__title {
        margin-top: 1em;
    }

    &.-bottom {
        svg {
            max-width: 12em;
        }
    }

    .l-section__intro--video-bg & {
        /* It seems that it will be always display non if there is a video */
        display: none;
    }

    @media #{md("xs")} {
        &:not(.-bottom) {
            /* left: calc(-26% / 2); */

            svg {
                /* width: 126% !important; */
                width: 120% !important;
            }
        }
    }

    @media #{$breakpoint-vertical} {
        &.-bottom {
            margin-top: 1em;

            svg {
                width: 50%;
            }
        }
    }

    @media #{$breakpoint-horizontal} {
        &.-bottom {
            position: absolute;
            bottom: 3em;
        }
    }

    @media #{md("md")} {
        &.-bottom {
            bottom: 1em;
        }
    }
}

.l-section__title {
    /* max-width: 600px; // make sure the title of entrepreneur isn't too wide */

    @media #{md("xs", "max")} {
        .o-icon {
            &.-arrow-up-right {
                left: 0;

                & + span {
                    display: block;
                    padding-right: 0.85em;
                    padding-left: 0.85em;
                }
            }

            &.-arrow-up-left {
                right: 0;
            }
        }
    }

    @media #{md("xs")} {
        .o-icon {
            &.-arrow-up-right {
                right: calc(100% + 0.1em);
            }
            &.-arrow-up-left {
                left: calc(100% + 0.1em);
            }
        }
    }

    .o-icon {
        position: absolute;
        font-size: 0.75em;

        &.-arrow-up-right {
            top: 0.2em;
        }

        &.-arrow-up-left {
            bottom: 0.2em;
        }
    }

    /* &__kicker {
    @include t3-heavy-bold;
  } */
}

.l-section__img {
    @media #{$breakpoint-vertical} {
        left: calc(50% - 50vw);
        width: 100vw;
        padding-top: 2em;
    }

    @media #{$breakpoint-horizontal} {
        // padding bottom (.l-section__intro)
        bottom: -3em;
        // padding left (.l-section__intro)
        left: -12vw;
        // 100% + padding left + padding right (.l-section__intro)
        width: calc(100% + 18vw);
        height: 100%;

        img {
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            height: calc(100% + 3em);
            object-fit: contain;
            object-position: 0 100%;
        }
    }
}

.l-section__bottom {
    display: flex;

    @media #{$breakpoint-vertical} {
        align-items: flex-end;
        margin-top: auto;
    }

    @media #{$breakpoint-horizontal} {
        position: absolute;
        right: 5vw;
        bottom: 1em;
        flex-direction: column;
        align-items: flex-end;
    }
}

.l-section__arrows {
    @media #{$breakpoint-vertical} {
        display: flex;
        flex-direction: column;

        .o-icon {
            margin-top: 0.75em;
            transform: rotate(90deg);
        }
    }

    @media #{$breakpoint-horizontal} {
        .o-icon {
            margin-left: 0.75em;
        }
    }
}

.l-section__push {
    @media #{$breakpoint-vertical} {
        margin-left: 1em;
    }

    @media #{$breakpoint-horizontal} {
        margin-top: 1em;
    }
}

.l-section__content {
    height: inherit;
}

.l-section__bg {
    position: absolute;
    top: 0;
    height: 100%;
    background-color: var(--color-bg);
    will-change: transform;
}

/*=============================
=            About            =
=============================*/

.-about {
    .l-section__intro {
        &.js-reveal {
            .c-box:before {
                transform: scale(0, 1);
                transform-origin: 0 50%;
            }

            .o-partners .o-icon,
            .o-partners .o-img {
                opacity: 0;
                transform: translate(0, 0.5em);
            }

            &.is-visible {
                .c-box:before {
                    transform: scale(1);
                    transition: transform 0.6s $out-quad;
                }

                .o-partners .o-icon,
                .o-partners .o-img {
                    opacity: 1;
                    transform: translate(0);

                    @for $i from 1 through 3 {
                        &:nth-child(#{$i}) {
                            $i: $i - 1;
                            transition: all 0.4s $out-quad #{$i/6 + 0.4}s;
                        }
                    }
                }

                .c-box__press {
                    @include anim-text-in(0.4, 0.4);
                }
            }
        }
    }

    .l-section__deco {
        overflow: hidden;

        .o-icon {
            font-size: 3em;
            flex-shrink: 0;
            color: $color-dark;
        }
    }

    .l-section__deco-inner {
        display: flex;
        will-change: transform;
    }

    .l-section__bottom {
        display: flex;
        max-width: none;

        a {
            display: inline-block;
            margin-left: auto;
        }
    }

    .l-section__push {
        margin-left: 0;
    }

    .c-box {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 3em 2em;
        margin-bottom: 1em;
        color: $color-lighter;

        &:before {
            @include pseudo-el($bg: $color-bright);
            position: absolute;
            top: 0;
            left: 0;
            pointer-events: none;
        }

        .c-btn {
            position: absolute;
            bottom: -$btn-height/2;
            left: 2em;
        }

        @media #{$breakpoint-vertical} {
            margin-right: auto;
            margin-left: auto;
        }

        @media #{$breakpoint-horizontal} {
            min-width: 50vmin;
        }
    }

    .c-box__press {
        font-weight: 400;
    }

    .o-partners {
        @include reset-list;
        display: grid;
        grid-template-columns: 1fr;
        grid-gap: 1.5em;
        margin-top: 2em;
        margin-bottom: 1em;
        padding-right: 6em;

        a {
            display: block;
            transition: all 0.3s $out-quad;

            &:hover {
                opacity: 0.8;
                transform: scale(0.95);
            }

            img {
                display: block;

                &.-risq {
                    max-height: 4.1em;
                }
                &.-fiducie {
                    max-height: 3.3em;
                }
            }
        }

        @media #{md("xs")} {
            grid-template-columns: repeat(2, 1fr);
        }
    }

    hr {
        margin: 2em 0;
        height: 1px;
        border: none;
        background: $color-lighter;
    }

    @media #{$breakpoint-vertical} {
        padding-top: 2em;

        .l-section__deco {
            left: calc(50% - 50vw);
            width: 100vw;
            margin-bottom: 1em;

            .o-icon {
                margin-right: 0.3em;
                transform: rotate(90deg);
            }
        }

        .l-section__deco-inner {
            padding-top: 0.2em;
            padding-bottom: 0.2em;
        }

        .l-section__bottom {
            flex-wrap: wrap;

            hr {
                width: 100%;
                border: 0;
                height: 1em;
            }
        }
    }

    @media #{$breakpoint-horizontal} {
        margin-left: 8vw;
        padding-left: 8vw;
        padding-right: 4em;

        .l-section__intro {
            align-items: flex-end;
            //width: calc(32em + 12vw * 2);
            width: calc(80vmin + 12vw * 2);
        }

        .c-box {
            width: 100%;
        }

        .l-section__deco {
            position: absolute;
            bottom: 0;
            left: -4vw;

            .o-icon {
                margin-top: 0.3em;
            }
        }

        .l-section__deco-inner {
            flex-direction: column;
        }

        .l-section__bottom {
            position: relative;
            right: auto;
            bottom: auto;
            flex-direction: row;
            width: 100%;
            margin-top: 0.4em;
            margin-left: auto;

            hr {
                display: none;
            }
        }

        .l-section__push {
            order: -1;
            margin-top: 0;
            transform: translateY(-2px); //UX
        }
    }
}

/*============================
=            Push            =
============================*/

.-push {
    .l-section__bg {
        transform: none !important;
        transition: background-color 0.8s $out-quad;
    }

    .l-section__link {
        position: absolute;
        top: 0;
        left: 0;
        display: block;
        width: 100%;
        height: 100%;
    }

    .l-section__header {
        pointer-events: none;
    }

    &:hover {
        .l-section__bg {
            background-color: $color-bright;
        }

        .t-link {
            &:before {
                transform: scale(1);
                transform-origin: 0 50%;
            }
        }
    }

    @media #{$breakpoint-vertical} {
        .l-section__intro {
            padding-bottom: 3em;
        }
    }

    @media #{$breakpoint-horizontal} {
        margin-right: calc(6vw + #{$header-bottom-height});
    }
}
</style>
